// src/pages/Home/Constants.js

const env = window._env_ || {};
const host = window.location.hostname;
const protocol = window.location.protocol; // e.g. 'http:' or 'https:'

// Helper function to build dynamic URLs
const getLink = (portKey, urlKey, defaultPort, path = "") => {
  if (env[urlKey]) return env[urlKey];
  const port = env[portKey] || defaultPort;
  return `${protocol}//${host}:${port}${path}`;
};

export const getModuleGroups = () => {
  const isDarkTheme = localStorage.getItem("theme") === "dark";

  return {
    skeye: [
      {
        id: "skeyenote",
        name: "Skeye note™",
        logo: `/img/majesteye-icon-skeye-note-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`,
        link: getLink("SKEYENOTE_PORT", "SKEYENOTE_URL", "8888"),
      },
      {
        id: "skeyecharts",
        name: "Skeye charts™",
        logo: `/img/majesteye-icon-skeye-charts-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`,
        link: getLink("SKEYECHARTS_PORT", "SKEYECHARTS_URL", "8088"),
      },
      {
        id: "skeyeingest",
        name: "Skeye ingest™",
        logo: `/img/majesteye-icon-skeye-ingest-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`,
        link: getLink("SKEYEINGEST_PORT", "SKEYEINGEST_URL", "18630"),
      },
      {
        id: "skeyecube",
        name: "Skeye cube™",
        logo: `/img/majesteye-icon-skeye-cube-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`,
        link: getLink("SKEYECUBE_PORT", "SKEYECUBE_URL", "7070", "/skeyecube"),
      },
      {
        id: "skeyeform",
        name: "Skeye form™",
        logo: "/img/skeyeform_initial_logo.svg",
        link: getLink("SKEYEFORM_PORT", "SKEYEFORM_URL", "5010"),
      },
      {
        id: "skeyepredict",
        name: "Skeye predict™",
        logo: `/img/majesteye-icon-skeye-predict-square-white-background-no-label${isDarkTheme ? "-white" : ""}.png`,
        link: getLink("SKEYEPREDICT_PORT", "SKEYEPREDICT_URL", "4200"),
      },
    ],
    bigData: [
      {
        id: "hadoop",
        name: "Hadoop",
        logo: `/img/Hadoop${isDarkTheme ? "_white" : ""}.svg`,
        link: getLink("HADOOP_PORT", "HADOOP_URL", "50070"),
      },
      {
        id: "spark",
        name: "Spark",
        logo: `/img/spark_nobg${isDarkTheme ? "_white" : ""}.png`,
        link: getLink("SPARK_PORT", "SPARK_URL", "8089"),
      },
      {
        id: "hive",
        name: "Hive",
        logo: "/img/hive.svg",
        link: getLink("HIVE_PORT", "HIVE_URL", "10002"),
      },
    ],
    governeye: [
      {
        id: "dghelper",
        name: "DGHelper™",
        logo: `/img/DGHELPER_nobg${isDarkTheme ? "_white" : ""}.png`,
        logoClass: "module-logo--governeye",
        link: getLink("DGHELPER_PORT", "DGHELPER_URL", "4300"),
      },
      {
        id: "fahras",
        name: "Fahras™",
        logo: "/img/Fahras_notext.png",
        logoClass: "module-logo--governeye",
        link: getLink("FAHRAS_PORT", "FAHRAS_URL", "5023"),
      },
      {
        id: "jeyeda",
        name: "Jeyeda™",
        logo: "/img/Jeyeda_logo_no_text.png",
        logoClass: "module-logo--governeye",
        link: getLink("JEYEDA_PORT", "JEYEDA_URL", "5000"),
      },
    ],
  };
};

export const statusConfig = {
  running: { color: "success", text: "Running" },
  stopped: { color: "warning", text: "Stopped" },
  "not-created": { color: "default", text: "Not Created" },
  unknown: { color: "default", text: "Unknown" },
};
